import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from '@driftt/tide-core-legacy'
import { propEq } from 'ramda'
import debounce from 'lodash.debounce'

class PardotProspectFieldSelect extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedFieldValue: '',
      fieldOptions: []
    }

    this.saveSelectedValue = debounce(this._saveSelectedValue, 1000)
  }

  componentDidMount() {
    this.getInitialState()
  }

  getInitialState = async () => {
    const selectedFieldValue = await this.getSelectedFieldValue()
    const fieldOptions = await this.getFieldOptions()

    this.setState({
      selectedFieldValue: selectedFieldValue,
      fieldOptions: fieldOptions
    })
  }

  getSelectedFieldValue = async () => {
    const { getSelectedField } = this.props
    let fieldName

    try {
      fieldName = await getSelectedField()
    }
    catch(e) {
      console.warn(e)
    }

    return fieldName || ''
  }

  getFieldOptions = async () => {
    const { fetchFields } = this.props
    let data

    try {
      data = await fetchFields()
    }
    catch(e) {
      console.warn(e)
    }

    const formatField = field => ({ label: field.displayName, value: field.name })
    const options = data.fields.filter(propEq('type', 'STRING')).map(formatField)

    return options
  }

  _saveSelectedValue = async () => {
    const { onSuccess, setSelectedField } = this.props
    const { selectedFieldValue } = this.state

    try {
      await setSelectedField(selectedFieldValue)
      onSuccess()
    }
    catch(e) {
      console.warn(e)
    }
  }

  handleSelectChange = selectedOption => {
    let newValue

    const selectionCleared = !selectedOption
    if (selectionCleared) {
      newValue = '' 
    } else {
      newValue = selectedOption.value
    }

    this.setState({
      selectedFieldValue: newValue
    }, this.saveSelectedValue)
  }

  render() {
    const { selectedFieldValue, fieldOptions } = this.state
    const disabled = !this.props.isEnabled

    return (
      <Select 
        className={'pardot-prospect-field-select'}
        options={fieldOptions}
        value={selectedFieldValue}
        disabled={disabled}
        onChange={this.handleSelectChange}
      />
    )
  }
}

PardotProspectFieldSelect.propTypes = {
  fetchFields: PropTypes.func.isRequired,
  getSelectedField: PropTypes.func.isRequired,
  setSelectedField: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  isEnabled: PropTypes.bool.isRequired,
}

export default PardotProspectFieldSelect


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotConfig/PardotProspectFieldSelect.js